// Corppass 任务分配给谁：一个人一个 Chrome（Corppass 一个人同一时间只能登录一个），出码时由他扫
import { useState } from "react";
import type { BrowserSlotDTO, TaskDTO } from "@csp/shared";
import { api, errorText } from "../lib/api";
import { useLoad } from "../lib/hooks";

/** 能登录 Corppass 的人（各自的 Chrome） */
export function useCorppassPeople(): { people: BrowserSlotDTO[]; error: string | null } {
  const q = useLoad(() => api.browsers(), []);
  return { people: (q.data ?? []).filter((b) => b.kind === "corppass"), error: q.error };
}

export function PersonSelect({ value, onChange, disabled, people }: { value: string | null; onChange: (v: string | null) => void; disabled?: boolean; people: BrowserSlotDTO[] }) {
  return (
    <select aria-label="谁来扫码登录 Corppass" value={value ?? ""} disabled={disabled} onChange={(e) => onChange(e.target.value || null)} style={{ width: "auto" }}>
      <option value="">选谁来扫码…</option>
      {people.map((p) => <option key={p.id} value={p.id}>{p.label}{p.busyTaskNo ? `（#${p.busyTaskNo} ${p.busyState === "running" ? "在跑" : "待命"}）` : ""}</option>)}
    </select>
  );
}

/** 任务页上的「扫码人」：Corppass 类型才显示；开始前可改 */
export function AssigneePicker({ task, onChanged }: { task: TaskDTO; onChanged: () => void }) {
  const { people, error: loadErr } = useCorppassPeople();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (task.browserKind !== "corppass") return null;
  const editable = ["draft", "ready", "failed"].includes(task.status);
  const save = async (v: string | null) => {
    setBusy(true); setError(null);
    try { await api.updateTask(task.id, { assignee: v }); onChanged(); }
    catch (e) { setError(errorText(e)); }
    finally { setBusy(false); }
  };
  return (
    <span className={`assignee${task.assignee ? "" : " assignee-none"}`} data-testid="assignee">
      <span className="small">扫码人</span>
      {editable ? <PersonSelect value={task.assignee ?? null} onChange={(v) => void save(v)} disabled={busy} people={people} /> : <b>{task.assigneeLabel ?? "未分配"}</b>}
      {(error || loadErr) && <span className="small err">{error ?? loadErr}</span>}
    </span>
  );
}
